<div class="ap-hint-dialog-container ap-px-3 ap-pb-2 ap-bg-white">
  <mat-dialog-content>
    <h4>{{ 'errorPrompt.heading'|content }}</h4>
    <p *ngIf="data.error.code && 'errorPrompt.messages.'+data.error.code|content">{{'errorPrompt.messages.'+data.error.code|content}}</p>
    <p *ngFor="let messageCode of data.error.apiError?.messageCodes">{{ 'errorPrompt.messages.' + messageCode|content }}</p>
    <div *ngIf="data.error.apiError">{{ 'errorPrompt.referenceLabel'|content:data.error.apiError }}</div>
  </mat-dialog-content>
</div>
